import type { Language } from '@offer-catalog/services/i18n'
import { VpAsset } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { Breadcrumb } from '@/components/Breadcrumb'
import { useProductsHeader } from '@/hooks/products'
import { getBreadcrumbForProductsPage } from '@/utils/breadcrumb'
import { ProductsHeaderActionChips } from './ProductsHeaderActionChips'
import { ProductsPageHeaderTitle } from './ProductsPageHeaderTitle'
import './products-page.scss'

export function ProductsPageHeader({ isProductsTabActive }: Readonly<{ isProductsTabActive: boolean }>) {
  const params = useParams()
  const { i18n, t } = useTranslation()

  const currentLanguage = i18n.language.split('-')[0] as Language
  const universeId = params.universeId as string
  const departmentId = params.departmentId as string

  const { contextId, data, isLoading, label, prefix } = useProductsHeader()

  return (
    <div className="products-header" data-testid="products_header">
      <Breadcrumb
        levels={getBreadcrumbForProductsPage({
          universe: data?.universe ?? { id: Number(universeId), labels: { fr: '', en: '' } },
          department: data?.department ?? { id: Number(departmentId), labels: { fr: '', en: '' } },
          currentLanguage,
        })}
      />
      <div className="products-header__image">
        <VpAsset name="logo-decathlon-lockup-stacked-brand" width="180px" />
      </div>
      <div className="products-header__content">
        <ProductsHeaderActionChips isProductsTabActive={isProductsTabActive} />
        <ProductsPageHeaderTitle
          contextId={contextId}
          data={data}
          isLoading={isLoading}
          label={label}
          prefix={prefix}
        />
        <div className="products-header__counts">
          <div className="products-header__counts__labels">
            {t('products-page.supermodels')}
            <span className="sr-only"> count :</span>
          </div>
          <div className="products-header__counts__value" data-testid="supermodel-count">
            {data?.supermodel_count}
          </div>
          <div className="products-header__counts__labels">
            {t('products-page.models')}
            <span className="sr-only"> count :</span>
          </div>
          <div className="products-header__counts__value" data-testid="model-count">
            {data?.model_count}
          </div>
        </div>
      </div>
    </div>
  )
}
